<template>
  <div>
    <div class="columns is-marginless">
      <div class="column"></div>
      <div class="column is-2">
        <b-button type="is-primary" @click="saveAllTask" expanded :loading="isLoadingSave">Guardar Cambios</b-button>
      </div>
    </div>
    <b-table
      :loading="isLoading"
      :per-page="perPage"
      :striped="true"
      :hoverable="true"
      :narrowed="true"
      :data="ironworks"
      :current-page.sync="currentPage"
      :mobile-cards="false"
      @click="rowClicked"
      @mouseenter="enterRow"
      @mouseleave="leaveRow"
      :paginated="false"
      :class="[{'max-content-table': ironworks.length > 0 && !isLoading }, {'opacity-last-row': !isHoverLastRow}]"
      :key="`iron-work-${$moment(date).format('L')}-${componentKey}`"
    >
      <template slot-scope="props">
        <b-table-column label="#" width="50" field="index" centered>
            <b-button type="is-danger" v-if="hoverRowId === props.row.id && props.index !== ironworks.length - 1" @click.stop="deleteRow(props.row)" :loading="(deleteLoading) && (selectedRow.id === props.row.id)">
                <b-icon icon="delete-outline"></b-icon>
            </b-button>
            <span v-else>{{ props.index + 1  }}</span>
        </b-table-column>
        <b-table-column label="Clasificación" width="100" field="type" >
          <b-select placeholder="Selecciona un tipo" v-model="props.row.taskable.horseshoe_work_id">
            <option
                v-for="option in horseshoeWorks"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
            </option>
          </b-select>
        </b-table-column>
        <b-table-column label="Caballo" width="230" field="horse" >
          <b-input @click.native="openHorseModal(props.row)" v-model="props.row.horse.name" :readonly="true"></b-input>
        </b-table-column>
        <!-- <b-table-column label="Último Herraje" width="120" field="last_ironwork" centered>

        </b-table-column> -->
        <b-table-column label="Categoría 1" width="120" field="category_one" centered>
          {{ props.row.horse.type ? props.row.horse.type.name : null}}
        </b-table-column>
        <b-table-column label="Categoría 2" width="120" field="category_two" centered>
          {{ props.row.horse.type && props.row.horse.type.category ? props.row.horse.type.category.name : null}}
        </b-table-column>
        <b-table-column label="Diagnostico" width="300" field="diagnostic" >
          <b-input v-model="props.row.taskable.diagnostic"></b-input>
        </b-table-column>
        <b-table-column label="Comentarios" width="300" field="comments" >
          <b-input v-model="props.row.taskable.observation"></b-input>
        </b-table-column>
        <!-- <b-table-column label="Insumos" field="supplies" centered>
          <b-button type="is-info">
            <b-icon icon="package-variant-closed"></b-icon>
          </b-button>
        </b-table-column> -->
      </template>
      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Cargando Caballos...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="horseshoe" size="is-large" />
            </p>
            <p>No hay registros de Caballos&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
    <find-horse-modal :horse-id="selectedRow && selectedRow.horse ? selectedRow.horse.id : null" :active.sync="isHorseModalActive" @confirm="selectHorse"/>
  </div>
</template>

<script>
// import ServiceService from '@/services/ServiceService'
import TaskUserService from '@/services/TaskUserService'
import HorseshoeService from '@/services/HorseshoeService'
import FindHorseModal from './FindHorseModal'
import HorseshoeWorkService from '@/services/HorseshoeWorkService'
import CredentialsService from '@/services/CredentialsService'
import HorseshoeTaskService from '@/services/HorseshoeTaskService'

export default {
  props: {
    reload: {
      type: Boolean,
      default: false
    },
    date: {
      type: Date,
      required: true
    },
    groupId: {
      required: true
    },
    serviceId: {
      required: true
    },
    tasks: {
      type: Array,
      default: () => []
    }
  },
  components: {
    FindHorseModal
  },
  created () {
    this.mapTasks()
    this.getHorseshoeWorks()
  },
  data () {
    return {
      horse: [],
      ironworks: [],
      paginated: true,
      perPage: 10,
      totalData: 0,
      isLoading: false,
      currentPage: 1,
      timer: null,
      isHoverLastRow: false,
      hoverRowId: null,
      selectedRow: null,
      isHorseModalActive: false,
      componentKey: 0,
      horseshoeWorks: [],
      deleteLoading: false,
      isLoadingSave: false
    }
  },
  methods: {
    async updateAllTask () {
      let formatDate = this.$moment(this.date).format('YYYY-MM-DD')
      let mapTasks = []
      for (let index = 0; index < this.ironworks.length; index++) {
        this.ironworks[index].start_date = formatDate
        this.ironworks[index].end_date = formatDate
        this.ironworks[index].group_id = this.groupId

        if (Number.isInteger(this.ironworks[index].id)) {
          let task = {
            'id': this.ironworks[index].id,
            'start_date': formatDate,
            'end_date': formatDate,
            'group_id': this.groupId
          }
          mapTasks.push(task)
        }
      }
      if (mapTasks.length > 0) {
        let object = {
          'task_users': mapTasks
        }
        await this.updateAllTaskUser(object)
      }
    },
    async saveAllTask () {
      this.isLoadingSave = true
      let createdTask = []
      let updatedTask = []
      for (const task of this.ironworks) {
        let taskable = task.taskable
        let horseId = task.horse.id
        let horseshoeWorkId = taskable.horseshoe_work_id
        if (horseId && horseshoeWorkId) {
          if (Number.isInteger(task.id)) {
            let mapHorseShoeTask = this.mapHorseShoeTask(task)
            updatedTask.push(mapHorseShoeTask)
          } else {
            let mapHorseShoeTask = this.mapHorseShoeTask(task)
            createdTask.push(mapHorseShoeTask)
          }
        }
      }

      await this.createHorseshoeTask({ list: createdTask })
      await this.updateHorseshoeTask({ list: updatedTask })

      this.isLoadingSave = false
      this.$emit('reload', true)
    },
    mapHorseShoeTask (task) {
      let taskable = task.taskable
      let horseId = task.horse.id

      let index = this.ironworks.findIndex((x) => x.id === task.id)
      let formatDate = this.$moment(this.date).format('YYYY-MM-DD')
      let horseshoeWork = this.horseshoeWorks.find((x) => x.id === taskable.horseshoe_work_id)

      let previusIndex = index - 1
      let startHour
      if (this.ironworks[previusIndex]) {
        startHour = this.ironworks[previusIndex].end_at
      } else {
        startHour = '08:00:00'
      }

      let minutesAdd = horseshoeWork.duration ? horseshoeWork.duration : 60

      let start = this.$moment(startHour, 'HH:mm:ss')
      let finish = this.$moment(startHour, 'HH:mm:ss').add(minutesAdd, 'm')
      let startFormated = start.format('HH:mm:ss')
      let finishFormated = finish.format('HH:mm:ss')
      task.start_at = startFormated
      task.end_at = finishFormated
      // console.log(`\n id: ${task.id} start: ${startFormated} finish: ${finishFormated} duration: ${horseshoeWork.duration} final-duration: ${minutesAdd}`)

      let horseShoe = {
        'apply_date': formatDate,
        'horse_id': horseId,
        'horseshoe_work_id': taskable.horseshoe_work_id,
        'created_by': this.userId,
        'diagnostic': taskable.diagnostic,
        'horseshoe_number': null,
        'horseshoe_model': null,
        'tenant_id': this.tenantId,
        'info': null,
        'observation': taskable.observation
      }

      let taskUser = {
        'user_id': this.userId,
        'horse_id': horseId,
        'start_date': formatDate,
        'start_at': startFormated,
        'end_date': formatDate,
        'end_at': finishFormated,
        'created_by': this.userId,
        'task_user_status_id': 1,
        'service_id': this.serviceId,
        'tenant_id': this.tenantId,
        'group_id': this.groupId
      }

      if (Number.isInteger(task.id)) {
        horseShoe.id = taskable.id
        taskUser.id = task.id
        horseShoe.horseshoe_id = taskable.id
      }

      return {
        'task_user': taskUser,
        'horse_shoe': horseShoe
      }
    },
    mapTasks () {
      this.ironworks = this.tasks
      if ((this.ironworks[this.ironworks.length - 1] && this.ironworks[this.ironworks.length - 1].horse.name) || this.ironworks.length === 0) {
        this.ironworks.push({ id: this.generateUID(), ...this.getBlanckIronWork() })
      }
    },
    rowClicked (row) {
      this.selectedRow = row
      let index = this.ironworks.findIndex((x) => x.id === row.id)
      if (index === (this.ironworks.length - 1)) {
        this.ironworks.push({ id: this.generateUID(), ...this.getBlanckIronWork() })
        this.isHoverLastRow = false
      }
    },
    enterRow (row) {
      let index = this.ironworks.findIndex((x) => x.id === row.id)
      if (index === (this.ironworks.length - 1)) {
        this.isHoverLastRow = true
      }
      this.hoverRowId = row.id
    },
    leaveRow (row) {
      let index = this.ironworks.findIndex((x) => x.id === row.id)
      // this.hoverRow = null
      if (index === (this.ironworks.length - 1)) {
        this.isHoverLastRow = false
      }
      this.hoverRowId = null
    },
    async deleteRow (row) {
      this.selectedRow = row
      let index = this.ironworks.findIndex((x) => x.id === row.id)
      if (index > -1) {
        if (Number.isInteger(row.id) && row.taskable.id) {
          this.selectedRow.deleted = true
          this.deleteLoading = true
          let deleteTask = await this.deleteTaskUser(row.id)
          let deleteHorses = await this.deleteHorseshoe(row.taskable.id)
          this.deleteLoading = false
          if (deleteTask.status === 200 && deleteHorses.status === 200) {
            this.ironworks.splice(index, 1)
          }
        } else {
          this.ironworks.splice(index, 1)
        }
        this.forceRerender()
      }
      this.selectedRow = null
    },
    openHorseModal (row, index) {
      this.selectedRow = row
      this.isHorseModalActive = true
      if (index === this.ironworks.length - 1) {
        this.rowClicked(row)
      }
    },
    selectHorse (data) {
      this.selectedRow.horse = data
    },
    generateUID () {
      return '_' + Math.random().toString(36).substr(2, 9)
    },
    async createHorseshoeTask (data) {
      let response = await HorseshoeTaskService.createHorseshoeTask(data)
      return response.data
    },
    async updateHorseshoeTask (data) {
      let response = await HorseshoeTaskService.updateHorseshoeTask(data)
      return response.data
    },
    async updateAllTaskUser (data) {
      let response = await TaskUserService.updateAllTaskUser(data)
      return response.data.data
    },
    async deleteTaskUser (taskUserId) {
      let response = await TaskUserService.deleteTaskUser(taskUserId)
      return response
    },
    async deleteHorseshoe (horseshoeId) {
      let response = await HorseshoeService.deleteHorseshoe(horseshoeId)
      return response
    },
    async getHorseshoeWorks () {
      let response = await HorseshoeWorkService.getHorseshoeWorks()
      this.horseshoeWorks = response.data.data
    },
    getBlanckIronWork () {
      let work = {
        horse: {
          name: null
        },
        taskable: {
          horseshoe_work_id: null,
          diagnostic: null,
          observation: null
        }
      }
      return JSON.parse(JSON.stringify(work))
    },
    forceRerender () {
      this.componentKey++
    }
  },
  computed: {
    userId () {
      return CredentialsService.getUser().id
    },
    tenantId () {
      return CredentialsService.getCurrentTenantId()
    }
  },
  watch: {
    reload (value) {
      if (value === true) {
        this.getServices()
      }
      this.$emit('update:reload', false)
    },
    tasks () {
      this.mapTasks()
    },
    date () {
      this.updateAllTask()
    }
  }
}
</script>

<style>
  .max-content-table .table-wrapper{
    overflow-x: auto !important;
  }

  .max-content-table .table-wrapper table.table{
    width: max-content !important;
  }

  .opacity-last-row table tbody tr:last-child {
    opacity: 0.5 !important;
  }

</style>
